module.exports = __webpack_public_path__ + "components/weather-icon/static/nightcloud@3-868c3cb1afead159a37187ccd0794145.png";